import { Component, OnInit } from '@angular/core';
import { PropietarioService } from '../../../../../shared/services/propietarios.service';

import {
  
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTooltip,
  ApexStroke
  } from "ng-apexcharts";

  export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  tooltip: ApexTooltip;
  dataLabels: ApexDataLabels;
  };

  export type ChartOptions2 = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    xaxis: ApexXAxis;
    stroke: ApexStroke;
    tooltip: ApexTooltip;
    dataLabels: ApexDataLabels;
    };
    export type ChartOptions3 = {
      series: ApexAxisChartSeries;
      chart: ApexChart;
      xaxis: ApexXAxis;
      stroke: ApexStroke;
      tooltip: ApexTooltip;
      dataLabels: ApexDataLabels;
      };

@Component({
  selector: 'app-graficos',
  templateUrl: './graficos.component.html',
  styleUrls: ['./graficos.component.scss']
})
export class GraficosComponent implements OnInit  {
  public chartOptions: any;
  public chartOptions2: any;
  public chartOptions3: any;

  porcentajeVencidos: number = 0;
  cantidadVencidos: number = 0;
  
  porcentajeVigente: number = 0;
  cantidaVigente: number = 0;

  porcentajePorVencer: number=0;
  cantidadPorVencer: number=0;


  constructor(private propietarioService: PropietarioService) {}

  ngOnInit() {
    this.propietarioService.estadisticas$.subscribe((estadisticas) => {
      if (estadisticas) {
      //  console.log(estadisticas);
        this.porcentajeVencidos = estadisticas.porcentajeVencidos;
        this.cantidadVencidos = estadisticas.vencidos;

        this.porcentajePorVencer = estadisticas.porcentajePorVencer;
        this.cantidadPorVencer = estadisticas.porVencer;

        this.porcentajeVigente = estadisticas.porcentajeVigentes;
        this.cantidaVigente = estadisticas.vigentes;

        this.cargarGrafico();
      }
    });
  }
  cargarGrafico() {

    this.chartOptions = {
      series: [this.porcentajeVencidos],
      chart: {
        height: 130,
        type: "radialBar",
        dropShadow: {
          enabled: true,
          top: 3,
          left: 0,
          blur: 10,
          color: "#FF3364",
          opacity: 0.35,
        },
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: "55%",
          },
          track: {
            strokeWidth: "60%",
            opacity: 1,
            margin: 5,
          },
          dataLabels: {
            showOn: "always",
            value: {
              color: "var(--body-font-color)",
              fontSize: "14px",
              show: true,
              offsetY: -10,
            },
          },
        },
      },
      colors: ["#FF3364"],
      stroke: {
        lineCap: "round",
      },
      responsive: [
        {
          breakpoint: 1500,
          options: {
            chart: {
              height: 130,
            },
          },
        },
      ],
    }

  this.chartOptions2 = {
    series: [this.porcentajePorVencer],
    chart: {
      height: 130,
      type: "radialBar",
      dropShadow: {
        enabled: true,
        top: 3,
        left: 0,
        blur: 10,
        color: "#EEBA11",
        opacity: 0.35,
      },
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: "55%",
        },
        track: {
          strokeWidth: "60%",
          opacity: 1,
          margin: 5,
        },
        dataLabels: {
          showOn: "always",
          value: {
            color: "var(--body-font-color)",
            fontSize: "14px",
            show: true,
            offsetY: -10,
          },
        },
      },
    },
    colors: ["#EEBA11"],
    stroke: {
      lineCap: "round",
    },
    responsive: [
      {
        breakpoint: 1500,
        options: {
          chart: {
            height: 130,
          },
        },
      },
    ],
  }
  
  this.chartOptions3 = {
    series: [this.porcentajeVigente],
    chart: {
      height: 130,
      type: "radialBar",
      dropShadow: {
        enabled: true,
        top: 3,
        left: 0,
        blur: 10,
        color: "#1DE279",
        opacity: 0.35,
      },
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: "55%",
        },
        track: {
          strokeWidth: "60%",
          opacity: 1,
          margin: 5,
        },
        dataLabels: {
          showOn: "always",
          value: {
            color: "var(--body-font-color)",
            fontSize: "14px",
            show: true,
            offsetY: -10,
          },
        },
      },
    },
    colors: ["#1DE279"],
    stroke: {
      lineCap: "round",
    },
    responsive: [
      {
        breakpoint: 1500,
        options: {
          chart: {
            height: 130,
          },
        },
      },
    ],
  }
}
  
  
  
}
